<template>
  <section>
    <h1>{{ $gettext('Payouts') }}</h1>

    <div
      v-if="isVerificationPanelShown"
      class="row"
    >
      <VerificationPanel class="col-12 col-8-medium" />
    </div>

    <div class="row">
      <BalancePanel
        class="col-12 col-8-medium"
        @payout-request-sent="refreshHistory"
      />
      <div
        v-if="isPayoutPanelShown"
        class="col-6-small is-hidden-above-medium is-hidden-below-small"
      />
      <PayoutMethods
        v-if="isPayoutPanelShown"
        class="col-12 col-6-small col-4-medium"
      />
    </div>

    <hr>

    <TransactionsHistory ref="historyRef" />
  </section>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import { useGettext } from 'vue3-gettext'
import { useStore } from 'vuex'
import BalancePanel from '@/components/BalancePanel.vue'
import PayoutMethods from '@/components/PayoutMethods.vue'
import VerificationPanel from '@/components/VerificationPanel.vue'
import TransactionsHistory from '@/components/TransactionsHistory.vue'

const { $gettext } = useGettext()
const store = useStore()
const historyRef = ref<InstanceType<typeof TransactionsHistory> | null>(null)

const isPayoutPanelShown = computed(
  () => !store.state.hasSubscriptionError
    && !store.getters.isSuspended
    && store.getters.isKycVerified
    && store.getters.isUserEmailVerified
    && (!store.getters.isSubscriptionMissing || !store.state.hasActiveReleases),
)

const isVerificationPanelShown = computed(
  () => store.state.hasSubscriptionError
    || store.getters.isSubscriptionMissing
    || !store.getters.isUserEmailVerified
    || store.getters.isSuspended
    || !store.getters.isKycVerified
    || store.getters.unverifiedActivePayoutMethods.length > 0,
)

const refreshHistory = () => {
  historyRef.value?.refreshHistory()
}
</script>

<style scoped>
hr {
  border: 1px solid var(--light-grey);
  border-bottom: 0;
}
</style>
